import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import './style.css';
import { ShouldRender } from '../../../../ui-core/ShouldRender';

export const Offer = ({
  coupon,
  couponFirst = false,
  mode = 'dark-mode',
  text = '20% Off for your first month',
}) => {
  const fill = useMemo(() => {
    switch (mode) {
      case 'dark-mode':
        return '#14142B';
      default:
        return '#FFFFFF';
    }
  }, [mode]);

  return (
    <fieldset className={mode}>
      <legend className={mode}>OFFER</legend>
      <div className="d-flex align-items-center">
        <div className="me-2">
          <Discount fill={fill} />
        </div>
        <div className="text-wrapper text-start">
          <ShouldRender check={!couponFirst}>
            <p className={`text-${mode} mb-0 text-danger fw-bold`}>{text}</p>
            <span className={`text-${mode} text-danger fw-bold`}>
              Using Code <b>{coupon}</b>
            </span>
          </ShouldRender>
          <ShouldRender check={couponFirst}>
            <span className={`text-${mode}`}>
              Code <b>{coupon}</b> gets you
            </span>
            <p className={`text-${mode} mb-0`}>{text}</p>
          </ShouldRender>
        </div>
      </div>
    </fieldset>
  );
};

const Discount = ({ fill }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3674_10439)">
      <path
        d="M29.8722 16.4146C29.7435 16.1511 29.7435 15.849 29.8722 15.5857L31.0657 13.1441C31.7302 11.7847 31.2037 10.1644 29.8671 9.45519L27.4665 8.18144C27.2075 8.04407 27.0299 7.79957 26.9792 7.51089L26.5097 4.83409C26.2483 3.34372 24.8697 2.34223 23.3718 2.55416L20.681 2.93479C20.3905 2.97579 20.1033 2.88241 19.8927 2.6786L17.9395 0.789113C16.8519 -0.263006 15.1482 -0.263069 14.0607 0.789113L12.1075 2.67879C11.8967 2.88266 11.6095 2.97585 11.3191 2.93498L8.62835 2.55435C7.12992 2.34229 5.75181 3.34391 5.49037 4.83428L5.02087 7.51095C4.97019 7.7997 4.79262 8.04413 4.53369 8.18157L2.13308 9.45531C0.796461 10.1644 0.269964 11.7849 0.93446 13.1443L2.12789 15.5858C2.25664 15.8492 2.25664 16.1513 2.12789 16.4147L0.934397 18.8562C0.269901 20.2156 0.796398 21.8359 2.13302 22.5451L4.53363 23.8189C4.79262 23.9562 4.97019 24.2007 5.02087 24.4894L5.49037 27.1662C5.72837 28.5229 6.89174 29.4744 8.22879 29.4743C8.36048 29.4743 8.4941 29.4651 8.62841 29.4461L11.3192 29.0654C11.6094 29.0243 11.8968 29.1178 12.1075 29.3216L14.0607 31.2111C14.6046 31.7372 15.3022 32.0002 16.0001 32.0002C16.6977 32.0001 17.3958 31.7371 17.9394 31.2111L19.8927 29.3216C20.1034 29.1178 20.3907 29.0247 20.681 29.0654L23.3718 29.4461C24.8704 29.6581 26.2483 28.6565 26.5097 27.1661L26.9793 24.4895C27.03 24.2007 27.2076 23.9563 27.4665 23.8189L29.8671 22.5451C31.2037 21.836 31.7302 20.2156 31.0657 18.8561L29.8722 16.4146ZM12.3088 7.69482C14.1745 7.69482 15.6924 9.21275 15.6924 11.0785C15.6924 12.9442 14.1745 14.4622 12.3088 14.4622C10.443 14.4622 8.9251 12.9442 8.9251 11.0785C8.9251 9.21275 10.443 7.69482 12.3088 7.69482ZM10.5623 22.7429C10.3821 22.923 10.1459 23.0132 9.90978 23.0132C9.67366 23.0132 9.43741 22.9231 9.25729 22.7429C8.89691 22.3825 8.89691 21.7982 9.25729 21.4378L21.4378 9.25731C21.7981 8.89694 22.3825 8.89694 22.7428 9.25731C23.1032 9.61769 23.1032 10.202 22.7428 10.5624L10.5623 22.7429ZM19.6912 24.3055C17.8255 24.3055 16.3076 22.7875 16.3076 20.9218C16.3076 19.0561 17.8255 17.5381 19.6912 17.5381C21.557 17.5381 23.0749 19.0561 23.0749 20.9218C23.0749 22.7875 21.557 24.3055 19.6912 24.3055Z"
        fill={fill}
      />
      <path
        d="M19.6912 19.3838C18.8431 19.3838 18.1531 20.0737 18.1531 20.9218C18.1531 21.7698 18.8431 22.4598 19.6912 22.4598C20.5392 22.4598 21.2292 21.7698 21.2292 20.9218C21.2292 20.0737 20.5392 19.3838 19.6912 19.3838Z"
        fill={fill}
      />
      <path
        d="M12.3087 9.54053C11.4607 9.54053 10.7708 10.2305 10.7708 11.0785C10.7708 11.9266 11.4607 12.6166 12.3087 12.6166C13.1568 12.6166 13.8468 11.9266 13.8468 11.0785C13.8467 10.2305 13.1568 9.54053 12.3087 9.54053Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_3674_10439">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Discount.propTypes = {
  fill: PropTypes.string,
};

Offer.propTypes = {
  coupon: PropTypes.string,
  couponFirst: PropTypes.bool,
  mode: PropTypes.string,
  text: PropTypes.string,
};
